import { useEffect, useState } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

export default function DrawingManager({ onPolygonComplete }) {
  const map = useMap();
  const [drawingMode, setDrawingMode] = useState(false);
  const [points, setPoints] = useState([]);
  const [polygon, setPolygon] = useState(null);

  // Initialize the temporary polygon for drawing
  useEffect(() => {
    if (!map || !window.google) return;

    const tempPolygon = new window.google.maps.Polygon({
      map: map,
      paths: [],
      fillColor: '#3b82f6', // primary color
      fillOpacity: 0.3,
      strokeWeight: 2,
      strokeColor: '#3b82f6',
      clickable: false,
    });
    setPolygon(tempPolygon);

    return () => {
      tempPolygon.setMap(null);
    };
  }, [map]);

  // Handle map clicks when in drawing mode
  useEffect(() => {
    if (!map || !drawingMode || !polygon || !window.google) return;

    const listener = map.addListener('click', (e) => {
      const newPoints = [...points, { lat: e.latLng.lat(), lng: e.latLng.lng() }];
      setPoints(newPoints);
      polygon.setPath(newPoints);
    });

    return () => {
      window.google.maps.event.removeListener(listener);
    };
  }, [map, drawingMode, points, polygon]);

  return (
    <div style={{ position: 'absolute', top: 10, left: '50%', transform: 'translateX(-50%)', zIndex: 10, display: 'flex', gap: '0.5rem', backgroundColor: 'rgba(255,255,255,0.9)', padding: '0.5rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      {!drawingMode ? (
         <button className="btn btn-primary" onClick={() => { 
           setDrawingMode(true); 
           setPoints([]); 
           if (polygon) polygon.setPath([]); 
         }}>
            ✏️ Draw New Area
         </button>
      ) : (
         <>
           <div style={{ padding: '0.5rem', fontSize: '0.9rem', fontWeight: 500 }}>Click on map to draw points...</div>
           <button className="btn btn-secondary" onClick={() => { 
             setDrawingMode(false); 
             setPoints([]); 
             if (polygon) polygon.setPath([]); 
           }}>
              Cancel
           </button>
           <button className="btn btn-primary" onClick={() => { 
              setDrawingMode(false); 
              if (points.length >= 3) {
                 if (onPolygonComplete) onPolygonComplete(points, polygon);
              } else {
                 alert("Please draw at least 3 points to make an area.");
                 setPoints([]); 
                 if (polygon) polygon.setPath([]);
              }
           }}>
              ✅ Finish Area
           </button>
         </>
      )}
    </div>
  );
}
